import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { TransferRequestsApi } from '@shared/api/rest';
import type { TransferRequestGetListRequest, TransferRequestResponse } from '@shared/api/rest/transferRequests';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';
import { ApiUtils } from '@shared/utils';

const effect = createEffect((params: IQueryParams<TransferRequestGetListRequest>) => TransferRequestsApi.getList(params.request, params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<{
  total: number;
  data: TransferRequestResponse[];
}>({
  data: [],
  total: 0,
})
  .on(effect.done, (_, values) =>
    values.result
      ? {
          total: values.result.total,
          data: values.result.data || [],
        }
      : { total: 0, data: [] },
  )
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, (_, data) => ApiUtils.abortApiFailCaseTrigger(data))
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => {
  ApiUtils.errorStoreAbortRequestWatcher(x, $notificationStore.events.setError);
});

export const $transferRequestsGridListStore = {
  events: {
    update: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Abort),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
